import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";
import { Text } from "nectar-ui";

export const DoubleColumnChartWrapper = styled.div<NectarTheme>`
  ${({ theme }) => css`
    width: 100%;

    .apexcharts-yaxis {
      font-weight: 800;
    }

    ${theme.breakpoints.sm} {
      width: calc(50% - 12px);
    }
  `}
`;

export const RadarChartContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    max-width: 1012px;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.lg} 0px;

    ${theme.breakpoints.sm} {
      flex-direction: row;
      gap: 0px ${theme.spacings.lg};
    }

    & span {
      flex-grow: 1;
    }
  `}
`;

export const StyledChartTitle = styled(Text)<NectarTheme>`
  ${({ theme }) => css`
    letter-spacing: normal !important;
    margin: 0 0 ${theme.spacings.sm} 0 !important;
    line-height: 140%;
  `}
`;
